(() => {
  if (customElements.get('el-product-question')) return;

  customElements.define('el-product-question', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.link = this.querySelector('a');
      this.note = this.querySelector('[data-inquiry-note]');
      if (!this.link || !this.productInfo) return;
      this.pending = false;
      this.selectionSequence = 0;
      this.onFormChange = (event) => {
        if (event.target.name !== 'id' || event.target.closest('product-info') !== this.productInfo) return;
        this.updateLink(this.readVariant());
      };
      this.onLinkClick = () => {
        if (!this.pending) this.updateLink(this.readVariant());
      };
      this.productInfo.addEventListener('change', this.onFormChange);
      this.link.addEventListener('click', this.onLinkClick);
      this.connectDawnEvents();
      this.onReady = () => this.connectDawnEvents();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      this.updateLink(this.readVariant());
    }

    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onFormChange);
      this.link?.removeEventListener('click', this.onLinkClick);
      document.removeEventListener('DOMContentLoaded', this.onReady);
      this.unsubscribeVariant?.();
      this.unsubscribeOption?.();
      this.unsubscribeVariant = null;
      this.unsubscribeOption = null;
    }

    connectDawnEvents() {
      if (this.unsubscribeVariant || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribeOption = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        if (data?.event?.target?.closest('product-info') !== this.productInfo) return;
        this.updateLink(null);
        this.pending = true;
        if (this.note) this.note.textContent = this.dataset.pendingNote;
        const selectionSequence = ++this.selectionSequence;
        const promise = this.productInfo.querySelector('variant-selects')?.pendingSelectPromise?.promise;
        promise?.catch(() => {
          if (this.pending && selectionSequence === this.selectionSequence && this.note) this.note.textContent = this.dataset.failedNote;
        });
      });
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const sectionId = this.productInfo.dataset.originalSection || this.productInfo.dataset.section;
        if (String(data?.sectionId) !== String(sectionId)) return;
        const current = this.readVariant();
        if (String(current?.id || '') !== String(data?.variant?.id || '')) return;
        this.updateLink(current);
      });
    }

    readVariant() {
      const script = this.productInfo.querySelector('variant-selects [data-selected-variant]');
      if (script) {
        try { return JSON.parse(script.textContent); } catch { return null; }
      }
      return this.dataset.variantId ? { id: this.dataset.variantId, title: this.dataset.variantTitle } : null;
    }

    updateLink(variant) {
      const productUrl = new URL(this.dataset.productUrl, window.location.origin);
      productUrl.search = '';
      productUrl.hash = '';
      const contactUrl = new URL(this.dataset.contactUrl, window.location.origin);
      contactUrl.search = '';
      contactUrl.searchParams.set('product_title', this.dataset.productTitle);
      const variantId = String(variant?.id || '');
      if (/^\d+$/.test(variantId)) {
        productUrl.searchParams.set('variant', variantId);
        contactUrl.searchParams.set('variant_id', variantId);
        const variantTitle = String(variant.title || '').trim();
        if (variantTitle && variantTitle.toLowerCase() !== 'default title') contactUrl.searchParams.set('variant_title', variantTitle);
      }
      contactUrl.searchParams.set('product_url', productUrl.pathname + productUrl.search);
      contactUrl.hash = 'ContactForm';
      this.link.href = contactUrl.pathname + contactUrl.search + contactUrl.hash;
      this.pending = false;
      if (this.note) this.note.textContent = this.dataset.readyNote;
    }
  });
})();
